export { DynamicTrackBackground } from './DynamicTrackBackground'